import { DirtyFieldsType, GetOperations } from '@occc-app/offerHelpers/types';

import { ConfigureFormValues, AWARD_TYPES } from '../../../types';
import { getIsStackableFieldDirty } from '../utils';
import { makeOfferUpdateOperation } from '../../../../../offerHelpers/operations/makeOfferUpdateOperation';

const getIsFuelRollbackOfferAndStackableDirty = (
  values: ConfigureFormValues,
  dirtyFields: DirtyFieldsType,
) => {
  const isStackableFieldDirty = getIsStackableFieldDirty(dirtyFields);
  return values.awardType === AWARD_TYPES.FUEL_ROLLBACK && isStackableFieldDirty;
};

const getIsNotFuelRollbackOfferAndStackable = (values: ConfigureFormValues) => {
  return values.awardType !== AWARD_TYPES.FUEL_ROLLBACK && values.stackable === true;
};
export const getOfferStackableUpdateOperations: GetOperations = (
  offerId,
  offer,
  values: ConfigureFormValues,
  dirtyFields,
) => {
  if (getIsFuelRollbackOfferAndStackableDirty(values, dirtyFields)) {
    return [makeOfferUpdateOperation(offerId, { stackable: values.stackable })];
  }

  if (getIsNotFuelRollbackOfferAndStackable(values)) {
    return [makeOfferUpdateOperation(offerId, { stackable: false })];
  }

  return [];
};
